import * as types from 'subapps/kb/actions'

const defaultState = {
  term: '',
}

const reducers = {}

reducers[types.UPDATE_FUZZY_SEARCH_TERM] = (state, action) => {
  const { term } = action.data
  return {
    ...state,
    term,
  }
}

reducers[types.UPDATE_FUZZY_SEARCH_IS_FOCUSED] = (state, action) => {
  const { isFocused } = action.data
  return {
    ...state,
    isFocused,
  }
}

export default function reducer(state = defaultState, action) {
  const handler = reducers[action.type]
  if (handler) return handler(state, action)
  return state
}
